/* eslint-disable */
/**
 * Select the `open` state of the `<Sidebar />`
 * @param {left|right} anchor The anchor
 * @returns {boolean} Whether or not the `<Sidebar /> is open or not
 */
const sidebarOpenSelector = (anchor) => (state) => state.sidebar[`open${anchor}`];

export default sidebarOpenSelector;
